import React, { Component } from 'react';
// import PropTypes from 'prop-types';
// import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import Ink from 'react-ink';
// import { NavLink } from 'react-router-dom';
import getButtons from '../../helpers/getButtons';
// import * as MenuActions from './MenuActions';
import NavigationComponent from './NavigationComponent';
// import * as ModalsActions from '../modals/ModalsActions';
import styles from './Style';
// import { MENU_BTN_CLICK } from './MenuConsts';

class MenuContainer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      tourType,
      tourId,
      buttonsParams,
      gallery,
      video,
      matterport,
      listingsCount
    } = this.props;
    const baseUrl = tourType
      ? `/${tourId}/${tourType.charAt(0)}`
      : `/${tourId}`;
    const links = getButtons(
      baseUrl,
      buttonsParams,
      gallery,
      video,
      matterport,
      listingsCount
    );
    return (
      <div className={styles.navigationWrapper}>
        <NavigationComponent btn={links} styles={styles} extended={false}/>
      </div>
    );
  }
}

// MenuContainer.propTypes = {
//     menuOpened: PropTypes.bool,
//     buttonsParams: PropTypes.object.isRequired,
//     video: PropTypes.shape({
//         videos: PropTypes.array,
//         videoType: PropTypes.string
//     }),
//     pathname: PropTypes.string
// };

const mapStateToProps = state => {
  return {
    menuOpened: state.menu.menuOpened,
    buttonsParams: state.menu.buttonsParams,
    video: state.video,
    matterport: state.matterport,
    gallery: state.gallery,
    tourId: state.app.tourId,
    tourType: state.app.tourType,
    listingsCount: state.listings.listingsCount,
    pathname: state.router.location.pathname
  };
};

const mapDispatchToProps = dispatch => {
  return {
    // menuActions: bindActionCreators(MenuActions, dispatch),
    // modalsActions: bindActionCreators(ModalsActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuContainer);
